module.exports = __webpack_public_path__ + "static/img/item-4-1.0e3fb9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-4-1.png
// module id = h1Uy
// module chunks = 2